// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#pageSubHeader[data-v-fdf4a6f8]{position:fixed;top:45px;width:100vw;z-index:2;background-color:#fff}", ""]);
// Exports
module.exports = exports;
